import { render, staticRenderFns } from "./BwGraduatedPrices.vue?vue&type=template&id=05f6802c"
import script from "./BwGraduatedPrices.vue?vue&type=script&lang=js"
export * from "./BwGraduatedPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports